import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const translationsUrl = import.meta.env.VITE_TRANSLATIONS_URL;

const getDomainBasedFallback = (): string => {
  if (typeof window !== 'undefined') {
    const urlEnding = window.location.hostname.split('.').pop();

    if (urlEnding === 'se') return 'sv-SE';
    if (urlEnding === 'dk') return 'da-DK';
    if (urlEnding === 'no') return 'nb-NO';
  }

  return 'sv-SE';
};

i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: {
      crossDomain: true,
      loadPath: `${translationsUrl}/{{lng}}.json`,
    },
    debug: import.meta.env.DEV,
    defaultNS: 'translation',
    fallbackLng: getDomainBasedFallback(),
    load: 'currentOnly',
    ns: ['translation'],
    supportedLngs: ['da', 'da-DK', 'fi', 'fi-FI', 'nb', 'nb-NO', 'sv', 'sv-SE'],
  });

// Required for screen readers to resolve correct language used.
i18next.on('languageChanged', (lng) => (document.documentElement.lang = lng));
